module.exports = __webpack_public_path__ + "static/img/vido_card.1cfd0ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/survery/vido_card.png
// module id = NH2i
// module chunks = 1